"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = require("../../ui/button");
var FormLayout = function (props) {
    var onSubmit = props.onSubmit, onCancel = props.onCancel, children = props.children, cancelLabel = props.cancelLabel, submitLabel = props.submitLabel;
    return (react_1["default"].createElement("form", { onSubmit: onSubmit },
        children,
        react_1["default"].createElement(button_1.Actions, { onCancel: onCancel, cancelLabel: cancelLabel, submitLabel: submitLabel })));
};
exports["default"] = FormLayout;
